import { render, staticRenderFns } from "./MerchantLogin.vue?vue&type=template&id=dbd177f2&scoped=true"
import script from "./MerchantLogin.vue?vue&type=script&lang=js"
export * from "./MerchantLogin.vue?vue&type=script&lang=js"
import style0 from "./MerchantLogin.vue?vue&type=style&index=0&id=dbd177f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd177f2",
  null
  
)

export default component.exports